import { api } from '../../../shared/api/client';
import type { ParametroSistemaDto, ParametroSistemaInput } from './types';

const BASE = '/v1/system-parameters';

export const parametrosApi = {
  async get(): Promise<ParametroSistemaDto> {
    const { data } = await api.get<{ data: ParametroSistemaDto }>(BASE);
    return data.data;
  },
  async update(input: ParametroSistemaInput): Promise<ParametroSistemaDto> {
    const { data } = await api.put<{ data: ParametroSistemaDto }>(BASE, input);
    return data.data;
  },
};
